module.exports = __webpack_public_path__ + "img/valentin.3cefeef4.jpg";